import { createAction } from 'redux-actions';
import { ApartmentAssets, DetailedIssueReport, IssueReport } from '../api/types';

export interface IssueReportsFetchedPayload {
    issueReports: IssueReport[];
}

export interface AssetsFetchedPayload {
    assets: ApartmentAssets[];
}

export interface IssueReportFetchedPayload {
    issueReport: DetailedIssueReport;
}

export interface IssueReportUpdatedPayload {
    id: string;
    enabled: boolean;
}

export interface IssueReportStatusUpdatedPayload {
    id: string;
    status: string;
}
export interface CreatedIssueReportPayload {
    success: boolean;
    /** The create was attempted and FAILED — distinct from `success: false`,
     *  which the form also dispatches to reset the flag after acting on it.
     *  Without this the two are indistinguishable, and the failure branch had
     *  to report `success: true` to release the form's loading overlay: the
     *  form then navigated away as if the report had been saved. */
    failed?: boolean;
    /** Id of the report just created. Only set on a successful create; it
     *  lets a flow that navigated to the form (e.g. the goodwill code form)
     *  come back with the new report already linked. */
    issueReportId?: string;
}

/* eslint-disable max-len */
const IssueReportEvents = {
    issueReportsFetched: createAction<IssueReportsFetchedPayload>(
        'ISSUE_RE_PORTS_FETCHED',
    ),
    /** The list fetch failed. Without it the store keeps whatever it held, and
     *  a failed load reads as "there are no reports" — to the list, the detail
     *  page and the CSV export alike. */
    issueReportsFetchFailed: createAction(
        'ISSUE_REPORTS_FETCH_FAILED',
    ),
    issueReportFetched: createAction<IssueReportFetchedPayload>(
        'ISSUE_RE_PORT_FETCHED',
    ),
    issueReportUpdated: createAction<IssueReportUpdatedPayload>(
        'ISSUE_REPORT_UPDATED',
    ),
    createdIssueReport: createAction<CreatedIssueReportPayload>(
        'ISSUE_REPORT_SUBMIT',
    ),
    updatedIssueReportStatus: createAction<IssueReportStatusUpdatedPayload>(
        'ISSUE_REPORT_STATUS_UPDATED',
    ),
    assetsFetched: createAction<AssetsFetchedPayload>(
        'ASSETS_FETCHED',
    ),
};

export default IssueReportEvents;
